import { apis } from "../../../constants";
import { common_post, HLog } from "../../../helpers";

//api load ds BỆNH NHÂN
export async function apiLayDsBenhNhan(dataRequest) {
  try {
    let res = await common_post(apis.lay_danh_sach_benh_nhan, dataRequest);
    
    if (res.status === "OK") {
      return res;
    }
    return;
  } catch (error) {
    HLog("Apis apiLayDsBenhNhan lỗi: ", error);
    return;
  }
}

//api load ds tỉnh
export async function apiLayDsTinh(dataRequest) {
  try {
    let res = await common_post(apis.lay_danh_sach_benh_nhan, dataRequest);
    
    if (res.status === "OK") {
      return res;
    }
    return;
  } catch (error) {
    HLog("Apis apiLayDsTinh lỗi: ", error);
    return;
  }
}

//api cập nhật nổi bật bệnh nhân
export async function apiCapNhatNoiBat(dataRequest) {
  try {
    let res = await common_post(apis.cap_nhat_noi_bat_bn, dataRequest);
    
    if (res.status === "OK") {
      return res;
    }
    return;
  } catch (error) {
    HLog("Apis apiCapNhatNoiBat lỗi: ", error);
    return;
  }
}

//api lấy thông tin chi tiết bệnh nhân
export async function apiThongTinChiTietBN(dataRequest) {
  try {
    let res = await common_post(apis.lay_thongtin_benh_nhan, dataRequest);
    
    if (res.status === "OK") {
      return res;
    }
    return;
  } catch (error) {
    HLog("Apis apiThongTinChiTietBN lỗi: ", error);
    return;
  }
}

//api sửa thông tin bệnh nhân
export async function apiSuaThongTinBN(dataRequest) {
  try {
    let res = await common_post(apis.tiep_don_sua_thong_tin_benh_nhan, dataRequest);
    
    if (res.status === "OK") {
      return res;
    }
    return;
  } catch (error) {
    HLog("Apis apiSuaThongTinBN lỗi: ", error);
    return;
  }
}

//api lấy lịch sử khám bệnh của bệnh nhân
export async function apiLichSuKhamBenh(dataRequest) {
  try {
    let res = await common_post(apis.khambenh_lay_lskb_benh_nhan, dataRequest);
    
    if (res.status === "OK") {
      return res;
    }
    return;
  } catch (error) {
    HLog("Apis apiLichSuKhamBenh lỗi: ", error);
    return;
  }
}

//api lấy ds lịch sử phiếu thu của bệnh nhân 
export async function apiDsPhieuThu(dataRequest) {
  try {
    let res = await common_post(apis.ds_phieu_thu_da_tao, dataRequest);
    
    if (res.status === "OK") {
      return res;
    }
    return;
  } catch (error) {
    HLog("Apis apiDsPhieuThu lỗi: ", error);
    return;
  }
}

//api lấy ds lịch sử bệnh chính của bệnh nhân 
export async function apiDsBenhChinh(dataRequest) {
  try {
    let res = await common_post(apis.lay_ds_benh_chinh, dataRequest);
    
    if (res.status === "OK") {
      return res;
    }
    return;
  } catch (error) {
    HLog("Apis apiDsBenhChinh lỗi: ", error);
    return;
  }
}

//api lấy ds khoa bệnh nhân đã khám
export async function apiDsKhoaDaKham(dataRequest) {
  try {
    let res = await common_post(apis.lay_khoa_bn_da_kham, dataRequest);
    
    if (res.status === "OK") {
      return res;
    }
    return;
  } catch (error) {
    HLog("Apis apiDsBenhChinh lỗi: ", error);
    return;
  }
}

//api lấy ds người đã tạo phiếu cho bệnh nhân
export async function apiDsNguoiTaoPhieu(dataRequest) {
  try {
    let res = await common_post(apis.lay_ds_nguoi_tao_phieu, dataRequest);
    
    if (res.status === "OK") {
      return res;
    }
    return;
  } catch (error) {
    HLog("Apis apiDsBenhChinh lỗi: ", error);
    return;
  }
}





